import { PAYMENT_BOOST_LANG_CODES, PAYMENT_BOOST_SID_CONFIG } from '@/base/const/paymentBoost.const'
import { CARD_TYPES, PAYWAY_GROUPS_TYPES } from '@/base/const/payway.const'
import { CookieClass } from '@/base/class/cookie.class'
import {
  COOKIE_CARD_DEPRECIATION_MECHANISM_ACTIVE,
  COOKIE_CARD_DEPRECIATION_MECHANISM_SHOW_GROUPS
} from '@/base/const/cookies.const'
import { MATOMO_EVENT_CATEGORY, MATOMO_EVENT_TYPE } from '@/base/const/matomo.const'
import { MatomoClass } from '@/base/class/matomo.class'

export class PaymentBoost {
  /**
   * Sprawdzenie czy mechanizm payment boost ma być aktywny
   * @param {number} serviceID
   * @param {number} amount
   * @returns {boolean}
   */
  static isPaymentBoostActive (serviceID, amount) {
    if (!serviceID) {
      return false
    }

    const pbItem = PAYMENT_BOOST_SID_CONFIG.find(item => Number(item.serviceId) === Number(serviceID))
    // jeśli SIDa nie ma na liście
    if (!pbItem) {
      return false
    }

    // jeśli kwota transkcji jest >= amount z konfiguracji
    if (Number(amount) >= Number(pbItem.transaction.amount)) {
      return true
    }

    // jeśli jeżyk przegladarki jest na liście, to stosujemy logikę optymalziacji
    const browserLang = navigator.language
    return PAYMENT_BOOST_LANG_CODES.includes(browserLang)
  }

  /**
   * Metoda sortująca wygenerowaną grupę list wg logiki payment boost (grupy kartowe na dół)
   * @param {array} groups
   * @returns {*[]}
   */
  static sortPaymentGroups (groups = []) {
    // szukamy grupy PROMO z kanałem 1500 i przesuwamy je na koniec
    const promoGroupIndex = groups.findIndex(group => group.type === PAYWAY_GROUPS_TYPES.promo)
    if (promoGroupIndex !== -1) {
      const cardPayway = groups[promoGroupIndex].payways.find(payway => payway.id === CARD_TYPES.creditCard.id)
      if (cardPayway) {
        groups.push(...groups.splice(promoGroupIndex, 1))
      }
    }

    // szukamy grupy CARDS i przesuwamy je na koniec
    const cardGroupIndex = groups.findIndex(group => group.type === PAYWAY_GROUPS_TYPES.card)
    groups.push(...groups.splice(cardGroupIndex, 1))

    // szukamy grupy WALLET i przesuwamy je na koniec
    const walletGroupIndex = groups.findIndex(group => group.type === PAYWAY_GROUPS_TYPES.wallet)
    groups.push(...groups.splice(walletGroupIndex, 1))

    // szukamy grupy VISAMOBILE i przesuwamy je na koniec
    const visaMobileGroupIndex = groups.findIndex(group => group.type === PAYWAY_GROUPS_TYPES.visaMobile)
    groups.push(...groups.splice(visaMobileGroupIndex, 1))

    return groups
  }

  static canSendCardDepreciationMechanismActiveEvent (transRemoteID) {
    const cookie = CookieClass.getCookie(COOKIE_CARD_DEPRECIATION_MECHANISM_ACTIVE)
    return !(cookie && cookie === String(transRemoteID))
  }

  static sendCardDepreciationMechanismActiveEvent (serviceId, transRemoteID) {
    const event = [
      MATOMO_EVENT_TYPE.trackEvent,
      MATOMO_EVENT_CATEGORY.costOptimization,
      'card_depreciation_mechanism_active',
      Number(serviceId),
      String(transRemoteID)
    ]
    MatomoClass.sendEvent(event)
    CookieClass.setCookie(COOKIE_CARD_DEPRECIATION_MECHANISM_ACTIVE, String(transRemoteID), 1)
  }

  static canSendCardDepreciationMechanismShowGroupsEvent (transRemoteID) {
    const cookie = CookieClass.getCookie(COOKIE_CARD_DEPRECIATION_MECHANISM_SHOW_GROUPS)
    return !(cookie && cookie === String(transRemoteID))
  }

  static sendCardDepreciationMechanismShowGroupsEvent (serviceId, transRemoteID) {
    const event = [
      MATOMO_EVENT_TYPE.trackEvent,
      MATOMO_EVENT_CATEGORY.costOptimization,
      'card_depreciation_mechanism_show_groups',
      Number(serviceId),
      String(transRemoteID)
    ]
    MatomoClass.sendEvent(event)
    CookieClass.setCookie(COOKIE_CARD_DEPRECIATION_MECHANISM_SHOW_GROUPS, String(transRemoteID), 1)
  }
}
